import { PAYMENT_ERRORS, PAYMENTS } from '../../api/endpoints';
import { baseApi, listTags } from './baseApi';

export const paymentsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getPayments: build.query({
      query: (params = {}) => ({ url: PAYMENTS.LIST, method: 'GET', params }),
      providesTags: (result) => listTags('Payment', result),
    }),
    getPaymentById: build.query({
      query: (arg) => {
        const id = typeof arg === 'object' && arg != null ? arg.id : arg;
        const params =
          typeof arg === 'object' && arg != null ? arg.params : undefined;
        return { url: PAYMENTS.BY_ID(id), method: 'GET', params };
      },
      providesTags: (_r, _e, arg) => [
        {
          type: 'Payment',
          id: typeof arg === 'object' && arg != null ? arg?.id ?? arg : arg,
        },
      ],
    }),
    updatePaymentStatus: build.mutation({
      query: ({ id, data: formData, ...body }) => {
        const payload = formData ?? body;
        const isFormData =
          typeof FormData !== 'undefined' && payload instanceof FormData;
        return {
          url: PAYMENTS.STATUS(id),
          method: isFormData ? 'POST' : 'PUT',
          data: payload,
          // FormData: omit Content-Type so axios sets multipart boundary
        };
      },
      invalidatesTags: (_r, _e, { id }) => [
        { type: 'Payment', id },
        { type: 'Payment', id: 'LIST' },
      ],
    }),
    getPaymentErrors: build.query({
      query: (params = {}) => ({
        url: PAYMENT_ERRORS.LIST,
        method: 'GET',
        params,
      }),
      providesTags: (result) => listTags('PaymentError', result),
    }),
    getPaymentErrorById: build.query({
      query: (arg) => {
        const id = typeof arg === 'object' && arg != null ? arg.id : arg;
        const params =
          typeof arg === 'object' && arg != null ? arg.params : undefined;
        return {
          url: PAYMENT_ERRORS.BY_ID(id),
          method: 'GET',
          params,
        };
      },
      providesTags: (_r, _e, arg) => [
        { type: 'PaymentError', id: typeof arg === 'object' && arg != null ? arg.id : arg },
      ],
    }),
  }),
});

export const {
  useGetPaymentsQuery,
  useLazyGetPaymentsQuery,
  useGetPaymentByIdQuery,
  useLazyGetPaymentByIdQuery,
  useUpdatePaymentStatusMutation,
  useGetPaymentErrorsQuery,
  useLazyGetPaymentErrorsQuery,
  useGetPaymentErrorByIdQuery,
  useLazyGetPaymentErrorByIdQuery,
} = paymentsApi;
